import { FC, ReactElement } from 'react'

const Divider: FC<{}> = (_props): ReactElement => {
	return <div className="w-[calc(100%+1rem)] ml-[-.5rem] h-[1px] bg-border my-1" />
}

export default Divider
